import { ActionService } from 'dashboard-services/services';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_TASK_INSPECTOR'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')
  return {
    CHANGE_VALUE,
    changeValue
  }
})()